<template>
  <div class='fuwu'>
    <img class="image" src="@/assets/renew/fuwuinfo.png" alt="">
    <img class="gostore" src="@/assets/renew/gostore.png" @click="gostore"/>
  </div>
</template>

<script>
export default {
  name: 'fuwu',
  components:{ 
    
  },
  data() {
    return {
        
    }
  },
  computed:{ },
  watch:{ },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
    gostore() {
      this.$router.push('/serve/store')
    }
  }
}
</script>
<style lang='less' scoped>
.fuwu {
  background: #fff;
  position: relative;
  .image {
    width: 1420px;
    height: 3722px;
    margin: 86px 250px;
  }
  .gostore {
    width: 288px;
    height: 70px;
    position: absolute;
    top: 2710px;
    left: 990px;
    cursor: pointer;
    animation: sclac 1.5s linear infinite;
  }
  @keyframes sclac {
    50% {
      transform: scale(1.1);
    }
  }
}
</style>